export default "__VITE_ASSET__9Q7zFVK$__"